import { IXmlNode } from '@/app-modules/server-communications';
import { safeCast } from '@/helper';

class WinnerCatchupData {
  public gameId: number;
  public prizes: WinnerCatchupPrize[];

  constructor(node: IXmlNode) {
    this.gameId = safeCast(node.attributes.gameno, 0);
    this.prizes = this.buildPrizeArray(node);
  }

  public isJackpotWon(): boolean {
    return this.prizes.filter((prize) => prize.isJackpotWon()).length > 0;
  }

  private buildPrizeArray(node: IXmlNode): WinnerCatchupPrize[] {
    const prizeNodes = node.childNodes.prize || [];
    return prizeNodes.map((prizeNode) => new WinnerCatchupPrize(prizeNode));
  }
}

class WinnerCatchupPrize {
  public level: number;
  public quantity: number;
  public winners: WinnerCatchupPrizeWinner[];

  constructor(node: IXmlNode) {
    this.level = safeCast(node.attributes.level, 0);
    this.quantity = safeCast(node.attributes.quantity, 0);
    this.winners = this.buildWinnerArray(node);
  }

  public isJackpotWon(): boolean {
    return this.winners.filter((winner) => winner.jackpotWon).length > 0;
  }

  private buildWinnerArray(node: IXmlNode): WinnerCatchupPrizeWinner[] {
    const winnerNodes = node.childNodes.winner || [];
    return winnerNodes.map((winnerNode) => new WinnerCatchupPrizeWinner(winnerNode));
  }
}

class WinnerCatchupPrizeWinner {
  public username: string;
  public prizeInPence: number;
  public jackpotWon: boolean;
  public callNumber: number;

  constructor(node: IXmlNode) {
    this.username = node.attributes.user;
    this.prizeInPence = safeCast(node.attributes.prize, 0);
    this.jackpotWon = safeCast(node.attributes.jackpot, false);
    this.callNumber = safeCast(node.attributes.call, 0);
  }

  public get prizeName(): string {
    return this.jackpotWon ? 'Jackpot' : 'Prize';
  }

  private get prizeType(): string {
    return this.jackpotWon ? 'jackpot' : 'prize';
  }
}

export { WinnerCatchupData, WinnerCatchupPrize, WinnerCatchupPrizeWinner };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/server/winner-catchup/winner-catchup-data.ts